<template>
  <v-dialog v-model="show" persistent fullscreen hide-overlay transition="dialog-bottom-transition" class="pa-2 preview-dialog">
    <v-toolbar dark color="primary" dense fixed app class="elevation-0 testtest">
      <p class="subtitle mb-0">{{ $t("attendees.filename") }}: {{ this.file_name }}</p>
      <v-spacer></v-spacer>
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid style="height: calc(100vh - 48px)" class="pa-0 preview-container">
      <v-layout fill-height>
        <v-flex xs12>
          <!--<iframe v-if="file_ext == 'pdf'" width="100%" height="100%" :src="file_src" frameborder="0" allowfullscreen></iframe>-->
          <!--<pdf-viewer v-if="file_ext == 'pdf'" :src="file_src"/>-->
          <VuetifyPdf v-if="file_ext == 'pdf'" :url="file_src"> </VuetifyPdf>
          <v-img v-else-if="valid_image_ext.includes(file_ext)" :src="file_src" height="100%" contain class="grey darken-4"></v-img>
          <div v-else>
            <v-container fluid fill-height style="height: 100vh" class="pa-0 preview-dialog">
              <v-layout align-center justify-center fill-height>
                <p class="subtitle-1 white--text">{{ $t("global.preview_not_available") }}</p>
              </v-layout>
            </v-container>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
import VuetifyPdf from "@/mixins/vuetify-pdfjs/src/App.vue"
import heic2any from "heic2any"

export default {
  props: {
    show: { type: Boolean },
    filename: { type: String },
    src: { type: String }
  },
  components: {
    //"pdf-viewer": () => import("@/mixins/components/pdfViewer"),
    VuetifyPdf
  },
  data() {
    return {
      file_src: null,
      file_ext: null,
      file_name: null,
      valid_image_ext: ["jpg", "jpeg", "png", "heic"],
      width: window.innerWidth - 90
    }
  },
  watch: {
    show: {
      handler() {
        if (this.show) {
          this.init()
        }
      }
    }
  },
  methods: {
    async init() {
      this.file_name = this.filename
      this.file_ext = this.$getFileExtension(this.filename)

      if (this.file_ext == "heic") {
        var blobURL = this.src
        var blobRes = await fetch(blobURL)
        var blob = await blobRes.blob()
        var resultBlob = await heic2any({ blob })
        var url = URL.createObjectURL(resultBlob);
        this.file_src = url
      } else {
        this.file_src = this.src
      }
    },
    close() {
      this.file_src = null
      this.file_name = null
      this.file_ext = null
      this.$emit("callback_close_preview")
    }
  }
}
</script>
<style>
.preview-container {
  /*margin-top: 48px !important;*/
}
.preview-dialog {
  background: rgb(42, 42, 42) !important;
}
.pdf-viewer__header {
  background: rgb(42, 42, 42) !important;
  padding: 0 !important;
}
.pdf-viewer__document {
  top: 84px !important;
}
.pdf-viewer__preview {
  background: rgb(42, 42, 42) !important;
}
.pdf-preview-toggle button {
  color: #fff !important !important !important;
}
.pdf-zoom.header-item button {
  color: #fff !important;
}
.pdf-paginator {
  color: #fff !important;
}
.pdf-paginator input {
  width: 50px !important;
  color: #fff !important;
}
.pdf-paginator input[type="number"]::-webkit-inner-spin-button,
.pdf-paginator input[type="number"]::-webkit-outer-spin-button {
  opacity: 1;
}
</style>
